
/* injects from baggage-loader */

'use strict';

export default function (app) {
  app
  .factory('Session', SessionFactory);

  function SessionFactory($state) {
    'ngInject';

    let self = {
      enabled: true
    };

    self.$state = $state;

    self.create = function(){
      let updates = {};
      
      updates = {
        stages:[
        {
          name: "Editorial",
          route: "page-two",
          completed: false
        },
        {
          name: "Infográfico Brincar",
          route: "page-four",
          completed: false
        },
        {
          name: "Caçando brincadeiras",
          route: "page-five",
          completed: false
        },
        {
          name: "Entrevista",
          route: "page-six",
          completed: false
        },
        {
          name: "O que é, o que é",
          route: "page-seven",
          completed: false
        },
        {
          name: "Cartas dos leitores - Canudinhos descartáveis",
          route: "page-eight",
          completed: false
        },
        {
          name: "Entre lacunas",
          route: "page-nine",
          completed: false
        },
        {
          name: "Envie sua carta do leitor!",
          route: "page-ten",
          completed: false
        }
        ],
        letter: []
      };

      // set shared currentUser
      // $rootScope.$currentUser = user

      return sessionStorage.$session = JSON.stringify(updates);
    }

    self.save = function(updates, all){
      if(all){
        sessionStorage.$session = JSON.stringify(updates);
      } else{
        sessionStorage.$session = JSON.stringify({ stages: updates.stages });
      }
      return 
    }

    self.saveLetter = function(letter){
      sessionStorage.$session = JSON.stringify({ letter: letter });
      return 
    }

    self.get = function(){
      try {
        return JSON.parse(sessionStorage.$session);        
      } catch (error) {
        return undefined;
      }
    }

    self.destroy = function(){
      delete sessionStorage.$session;
      return $state.go('login');
    }

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/session.factory.js